const initialState = () => {
    return {
        businessRegisterData: {
            firstName: null,
            lastName: null,
            email: null,
            corporateName: null,
            addressStreet: null,
            addressBuildingNumber: null,
            addressApartmentNumber: null,
            addressPostal: null,
            addressCity: null,
            addressCountry: 'POLAND',
            nip: null,
            phoneNumber: null,
        },
        userData: {
            firstName: null,
            lastName: null,
            phoneNumber: null,
            email: null,
        },
    };
};

const state = initialState();

const getters = {
    getBusinessRegisterData: (state) => {
        return state.businessRegisterData;
    },
    getUserData: (state) => {
        return state.userData;
    },
};

const mutations = {
    setBusinessRegisterData(state, businessUserData) {
        state.businessRegisterData = businessUserData;
    },
    setUserData(state, userData) {
        state.userData = userData;
    },
};

const actions = {
    setBusinessRegisterData({commit}, businessUserData) {
        commit('setBusinessRegisterData', businessUserData);
    },
    setUserData({commit}, userData) {
        commit('setUserData', userData);
    },
    resetUserData({commit}) {
        commit('setUserData', initialState().userData);
    },
    resetBusinessRegisterData({commit}) {
        commit('setBusinessRegisterData', initialState().businessRegisterData);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
